import React from 'react';
import { CTAButton } from './CTAButton';
export function IncludesSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const modules = [{
    icon: '📘',
    title: 'Tomo 1: Luxury Brow Extensions',
    description: 'Vas a aprender a fondo sobre: extensión de cejas pelo por pelo, mapping, diseño estratégico, visagismo, simetría facial, corrección de huecos, acabado hiperrealista, laminado, colorimetría, mantenimiento y retoques.'
  }, {
    icon: '📖',
    title: 'Tomo 2: Guía Práctica Paso a Paso',
    description: 'Aprendé en detalle cómo se realiza la técnica correctamente. Protocolo de aplicación, dirección del vello, fijación, reconstrucción, acabado premium y los errores comunes que debés evitar.'
  }, {
    icon: '📲',
    title: 'Tomo 3: Pack Marketing para Conseguir Clientas',
    description: 'Incluye: ✅ ideas de reels ✅ contenido viral ✅ fotos que venden ✅ branding beauty premium ✅ estrategias para Instagram ✅ cómo captar clientas que ya se hacen pestañas y microblading.'
  }, {
    icon: '💰',
    title: 'Tomo 4: Estrategia de Negocio y Fidelización',
    description: 'Transformá este servicio en ingresos mensuales, aprendé a: cómo crear mantenimientos, cómo hacer retoques recurrentes, cómo aumentar tu ticket promedio y cómo vender packs mensuales.'
  }];
  return <section className="py-8 md:py-12 px-4 bg-[#2E0640] pt-[0px] pb-[0px] mt-[50px] mb-[50px]" data-id="element-210">
      <div className="max-w-6xl mx-auto mt-[-30px] mb-[-30px]" data-id="element-211">
        <h2 className="text-4xl md:text-5xl font-black text-center text-[#FFFFFF] mt-[35px] mb-[35px] pt-[10px] pb-[10px]" data-id="element-212">
          ¿Qué incluye exactamente?
        </h2>

        <div className="flex justify-center mb-12" data-id="element-213">
          <img src="https://cdn.magicpatterns.com/uploads/vEcpvjUWffYDSFvQx2aTWp/mockup_dominando_shopify_(2).png" alt="Luxury Brow Extensions - Mockup Completo" className="w-full max-w-3xl rounded-2xl mt-[-23px] mb-[-23px] pt-[0px] pb-[0px] animate-neon-pink" data-id="element-214" />
        </div>

        <div className="bg-gradient-to-br from-gray-900 to-gray-800 text-white rounded-2xl p-8 md:p-12 bg-[#2F0240] animate-neon-violet pt-[35px] pb-[35px] mt-[30px] mb-[30px]" data-id="element-215">
          <h3 className="font-bold mb-8 text-center text-[24px] text-[#FFFFFF]" data-id="element-216">
            El sistema completo ✨Brow Extensions✨
          </h3>
          <p className="mb-6 text-center text-gray-300 text-[20px]" data-id="element-217">
            📘27 clases con el paso a paso completo. 📙4 Tomos organizados. 📒5
            bonos estratégicos.
          </p>

          <div className="grid md:grid-cols-2 gap-5" data-id="element-218">
            {modules.map((module, index) => <div key={index} className="bg-gray-800 rounded-xl p-5 border border-[#FC9DFF]/20" data-id="element-219">
                <h4 className="text-white font-bold text-[17px] md:text-lg mb-2 leading-snug" data-id="element-220">
                  <span className="mr-1" data-id="element-221">{module.icon}</span>
                  {module.title}
                </h4>
                <p className="text-gray-300 text-[15px] md:text-base leading-relaxed" data-id="element-222">
                  {module.description}
                </p>
              </div>)}
          </div>
        </div>

        {/* Beneficios Header */}
        <div className="mt-12 text-center bg-gradient-to-r from-[#9C16A3] to-[#6B0F70] rounded-2xl p-8 border-2 border-purple-400/50" data-id="element-223">
          <h3 className="md:text-4xl font-black text-white uppercase mb-2 text-[23px]" data-id="element-224">
            ¿QUÉ VAS A LOGRAR?⭐⭐⭐⭐⭐
          </h3>
          <div className="space-y-4 text-left max-w-xl mx-auto mt-4" data-id="element-225">
            <div className="flex items-start gap-3" data-id="element-226">
              <span className="text-green-400 text-2xl leading-none mt-0.5" data-id="element-227">
                ✔
              </span>
              <p className="md:text-xl text-purple-100 text-[17px] font-[500]" data-id="element-228">
                Actualizarte en la nueva Tendencia del momento
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-229">
              <span className="text-green-400 text-2xl leading-none mt-0.5" data-id="element-230">
                ✔
              </span>
              <p className="md:text-xl text-purple-100 text-[17px] font-[500]" data-id="element-231">
                Posicionarte como experta
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-232">
              <span className="text-green-400 text-2xl leading-none mt-0.5" data-id="element-233">
                ✔
              </span>
              <p className="md:text-xl text-purple-100 text-[17px] font-[500]" data-id="element-234">
                Ser una de las primeras en ofrecer el servicio
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-235">
              <span className="text-green-400 text-2xl leading-none mt-0.5" data-id="element-236">
                ✔
              </span>
              <p className="md:text-xl text-purple-100 text-[17px] font-[500]" data-id="element-237">
                Resultados hiperrealistas en tus clientas
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-238">
              <span className="text-green-400 text-2xl leading-none mt-0.5" data-id="element-239">
                ✔
              </span>
              <p className="md:text-xl text-purple-100 text-[17px] font-[500]" data-id="element-240">
                Que vuelvan cada mes por este servicio Premium
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-241">
              <span className="text-green-400 text-2xl leading-none mt-0.5" data-id="element-242">
                ✔
              </span>
              <p className="md:text-xl text-purple-100 text-[17px] font-[500]" data-id="element-243">
                Ahorrar tiempo y dinero con un método que ya funciona
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}